module.exports = __webpack_public_path__ + "img/meralco_logo@2x.2da59363.png";